import { render, staticRenderFns } from "./HeadlineImage.vue?vue&type=template&id=36dccdd3"
import script from "./HeadlineImage.vue?vue&type=script&lang=ts"
export * from "./HeadlineImage.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineImage.vue?vue&type=style&index=0&id=36dccdd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports